export default function BPLogComponent({ logsBP }) {
    return (
        <div className="space-y-2 pr-1 pt-1">
            {logsBP.length === 0 ? (
                <p className="text-center text-sm text-muted-foreground py-8">Nenhum log encontrado.</p>
            ) : (
                logsBP.map((log) => (
                    <div
                        key={log.id}
                        className="rounded-xl border border-border shadow-xs bg-card p-3"
                    >
                        {/* Topo: usuário + data */}
                        <div className="flex items-center justify-between mb-3 pb-2 border-b border-border">
                            <div className="flex items-center gap-2">
                                <span className="flex items-center justify-center w-6 h-6 rounded-full bg-accent text-accent-foreground text-[10px] font-bold uppercase">
                                    {log.usuario?.slice(0, 2)}
                                </span>
                                <span className="text-sm font-semibold text-foreground">{log.usuario?.split("@")[0]}</span>
                            </div>
                            <span className="text-xs text-muted-foreground">
                              Data da Alteração:   {new Date(log.dataAlteracao).toLocaleString()}
                            </span>
                        </div>

                        {/* Campo alterado */}
                        <div className="mb-2">
                            <span className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground">
                                Campo Alterado
                            </span>
                            <p className="text-xs font-medium text-foreground">{log.campoAlterado}</p>
                        </div>

                        {/* Valores anterior/novo */}
                        <div className="grid grid-cols-2 gap-3">
                            <div className="rounded-lg bg-destructive/5 border border-destructive/15 p-2.5">
                                <span className="text-[10px] font-bold uppercase tracking-widest text-destructive/70">
                                    Anterior
                                </span>
                                <ValorLog valor={log.valorAnterior} cor="text-destructive" />
                            </div>
                            <div className="rounded-lg bg-success/5 border border-success/15 p-2.5">
                                <span className="text-[10px] font-bold uppercase tracking-widest text-success/70">
                                    Novo
                                </span>
                                <ValorLog valor={log.valorNovo} cor="text-success" />
                            </div>
                        </div>
                    </div>
                ))
            )}
        </div>
    )
}

function ValorLog({ valor, cor }) {
    const mapa = parseValorMapa(valor);

    if (!mapa) {
        return <p className={`text-sm ${cor} break-words`}>{valor || "—"}</p>;
    }

    return (
        <div className="grid grid-cols-2 gap-x-3 gap-y-1 mt-1">
            {mapa.map(({ chave, valor: v }) => (
                <div key={chave} className="flex items-center justify-between text-xs">
                    <span className="text-muted-foreground capitalize">{chave.toLowerCase()}</span>
                    <span className={`font-semibold ${cor}`}>{formatarMoeda(v)}</span>
                </div>
            ))}
        </div>
    );
}

function parseValorMapa(valor) {
    if (!valor || typeof valor !== "string" || !valor.startsWith("{")) {
        return null;
    }
    const conteudo = valor.replace(/^{|}$/g, "").trim();
    if (!conteudo) return null;

    return conteudo.split(",").map((par) => {
        const [chave, ...resto] = par.trim().split("=");
        return { chave: chave.trim(), valor: resto.join("=").trim() };
    });
}

function formatarMoeda(valor) {
    const num = Number(valor);
    if (isNaN(num)) return valor;
    return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}
